<div>
  <ng-content></ng-content>
</div>
<ng-container *ngIf="mobileVersion$ | async">
  <span class="kz-mesh-link--container--mobile__more" *ngIf="items?.length && items.length > meshLinkBreakPointLimit" (click)="toggle()">
    <ng-container *ngIf="!allLinksInMobile" i18n="@@meshLink.more">See more</ng-container>
    <ng-container *ngIf="allLinksInMobile" i18n="@@meshLink.less">See less</ng-container>
  </span>
</ng-container>

